import createLucideIcon from '../createLucideIcon';

const MoveDown = createLucideIcon('MoveDown', [
  ['path', { d: 'M8 18L12 22L16 18', key: 'cskvfv' }],
  ['path', { d: 'M12 2V22', key: 'r89rzk' }],
]);

export default MoveDown;
